var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"income-by-field"},[_c('div',[_c('div',{staticClass:"box chart-holder"},[_c('h2',[_vm._v(_vm._s(_vm.t("orderReports-charts-income_by_field", [_vm.label])))]),_vm._v(" "),_c('pie-chart',{attrs:{"chart-data":_vm.pieCustomerChartData,"height":218,"value-prefix":_vm.currencySymbol}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }